import Vue from 'vue';
import Router from 'vue-router';

import MainRoutes from './Routers/Main';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    ...MainRoutes
  ],
});
